export const scale_types = {
  months: 'months',
  weeks: 'weeks',
  years: 'years',
  days: 'days',
}
